// PANTAU app configuration + accent palettes + localStorage persistence.

export const ACCENT_PALETTES = [
  { id: "tactical-cyan", name: "Tactical Cyan", hex: "#06b6d4", grad: "from-cyan-500 to-blue-600" },
  { id: "radar-crimson", name: "Radar Crimson", hex: "#f43f5e", grad: "from-rose-500 to-red-600" },
  { id: "neon-amber", name: "Neon Amber", hex: "#f59e0b", grad: "from-amber-500 to-orange-600" },
  { id: "emerald-ops", name: "Emerald Ops", hex: "#10b981", grad: "from-emerald-500 to-teal-600" },
  { id: "ultraviolet", name: "Ultraviolet Grid", hex: "#8b5cf6", grad: "from-violet-500 to-purple-600" },
  { id: "electric-indigo", name: "Electric Indigo", hex: "#6366f1", grad: "from-indigo-500 to-blue-600" },
  { id: "slate-minimal", name: "Monochrome Tactical", hex: "#94a3b8", grad: "from-slate-400 to-slate-600" },
];

export const DEFAULT_CONFIG = {
  siteName: "PANTAU",
  siteSuffix: "",
  siteSubtitle: "Real-Time Multi-Hazard & Tectonic Intelligence",
  domainUrl: "",
  logoType: "monogram",
  logoMonogramChar: "P",
  logoIconName: "Radio",
  logoCustomUrl: "",
  accentColor: "tactical-cyan",
  defaultRegion: "indonesia",
  defaultLayers: { plates: true, volcanoes: true, wildfires: true, faults: true },
  defaultFeed: "combined",
  adminSecretPath: "/secret-admin-pantau",
  adminMasterPasswordHash: btoa("pantau2026admin"),
  soundAlarm: true,
  refreshInterval: 60,
};

const KEY = "pantau_config_v1";

export function loadConfig() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { ...DEFAULT_CONFIG };
    return { ...DEFAULT_CONFIG, ...JSON.parse(raw) };
  } catch {
    return { ...DEFAULT_CONFIG };
  }
}

export function saveConfig(cfg) {
  localStorage.setItem(KEY, JSON.stringify(cfg));
}

export function resetConfig() {
  localStorage.removeItem(KEY);
}

export function getAccent(cfg) {
  return ACCENT_PALETTES.find((p) => p.id === cfg.accentColor) || ACCENT_PALETTES[0];
}

export function checkPassword(cfg, input) {
  return btoa(input) === cfg.adminMasterPasswordHash;
}

export function setPassword(cfg, newPass) {
  return { ...cfg, adminMasterPasswordHash: btoa(newPass) };
}
